<template>
  <!-- TKT-000862: per-workstation override for the statement's middle section. Sits on the
       Taxroll Search / Owner Search action row between Print | Email and Pick List so the
       counter can switch back and forth without touching Settings > Statements. -->
  <div :title="hoverText">
    <v-select
      class="input-text-size tax-middle-section-select"
      :class="{ 'middle-section-overridden': isOverridden }"
      id="taxMiddleSectionSelect"
      label="Middle Section"
      :items="options"
      item-text="text"
      item-value="value"
      v-model="middleSection"
      hide-details
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
          <v-list-item-subtitle class="middle-section-option-hint">
            {{ item.description }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-select>
  </div>
</template>

<script>
import {
  COUNTY_SETTING,
  MIDDLE_SECTION_OPTIONS,
  getMiddleSection,
  setMiddleSection,
} from '../../../../util/statement-middle-section.util';

export default {
  name: 'MiddleSectionSelect',
  data() {
    return {
      options: MIDDLE_SECTION_OPTIONS,
      // Seeded from localStorage so the choice is already in place on the first paint after a
      // refresh or a re-login. The print/email call sites read localStorage directly rather
      // than this component, so there is nothing to keep in sync through Vuex.
      selected: getMiddleSection(),
    };
  },
  computed: {
    middleSection: {
      get() {
        return this.selected;
      },
      set(value) {
        this.selected = value;
        setMiddleSection(value);
      },
    },
    isOverridden() {
      return this.selected !== COUNTY_SETTING;
    },
    hoverText() {
      if (!this.isOverridden) {
        return 'What prints in the middle section of statements printed or emailed from this computer. County Setting follows Settings > Statements.';
      }
      return 'This computer is not following the county setting (Settings > Statements). The choice stays selected after a refresh or re-login on this computer; Reset does not change it.';
    },
  },
};
</script>

<style scoped>
/* Blue = this workstation is overriding the county setting, so the clerk can tell at a glance
   that what prints here is not what Settings > Statements says. */
.middle-section-overridden ::v-deep .v-select__selection,
.middle-section-overridden ::v-deep .v-label,
.middle-section-overridden ::v-deep .v-input__append-inner .v-icon {
  color: #1E88E5 !important;
}
.middle-section-overridden ::v-deep .v-input__slot::before {
  border-color: #1E88E5 !important;
}
.middle-section-option-hint {
  font-size: 11px;
}
</style>
